// Real-time price and date updates on the main auction listing page (cards with price and date).
// When an offer is made, the card updates instantly via ActionCable (no batch delay).
import consumer from "./consumer"

var MAX_IDS_PER_REFRESH = 60
var LISTING_REFRESH_DELAY_MS = 1500

// Parse displayed/formatted price (e.g. "230,00 €" or "2 500,00") to number for comparison.
function parsePriceToNumber(str) {
  if (str == null || typeof str !== "string") return NaN
  var cleaned = str.replace(/\s/g, "").replace(",", ".").replace(/[^\d.-]/g, "")
  return parseFloat(cleaned) || NaN
}

function applyListingUpdate(auctionId, data) {
  if (data.highest_ad_bid == null && data.ad_publication_date == null) return
  const idStr = String(auctionId)
  const container = document.getElementById("pills-online-auction")
  let cards = container ? container.querySelectorAll("[data-auction-id=\"" + idStr + "\"]") : []
  if (!cards.length) cards = document.querySelectorAll("[data-auction-id=\"" + idStr + "\"]")
  cards.forEach(function (card) {
    if (data.highest_ad_bid != null && data.highest_ad_bid !== "") {
      const priceEl = card.querySelector(".item-price")
      if (priceEl) {
        var newPriceNum = parsePriceToNumber(data.highest_ad_bid)
        var currentPriceNum = parsePriceToNumber(priceEl.textContent)
        // Only update if new price is >= current (avoids stale listing_prices cache overwriting real-time value)
        if (isNaN(currentPriceNum) || newPriceNum >= currentPriceNum) {
          priceEl.textContent = data.highest_ad_bid + " €"
        }
      }
    }
    if (data.ad_publication_date != null && data.ad_publication_date !== "") {
      const timeEl = card.querySelector(".item-time-value")
      if (timeEl) {
        timeEl.textContent = data.ad_publication_date
      } else {
        const itemTime = card.querySelector(".item-time")
        if (itemTime) {
          const textNode = Array.from(itemTime.childNodes).find(function (n) {
            return n.nodeType === Node.TEXT_NODE && n.textContent.trim()
          })
          if (textNode) textNode.textContent = " " + data.ad_publication_date
          else itemTime.appendChild(document.createTextNode(" " + data.ad_publication_date))
        }
      }
    }
  })
}

function subscribeToAuctionListing() {
  var sub = consumer.subscriptions.create("AuctionListingChannel", {
    received(data) {
      try {
        if (data.auction_id == null || (data.highest_ad_bid == null && data.ad_publication_date == null)) return
        applyListingUpdate(data.auction_id, data)
        scheduleDelayedListingRefresh()
      } catch (e) {
        console.warn("[AuctionListingChannel] update error:", e)
      }
    }
  })
  return sub
}

var _listingRefreshTimeout = null

function refreshListingPricesFromServer() {
  const container = document.getElementById("pills-online-auction")
  if (!container) return
  const cards = container.querySelectorAll("[data-auction-id]")
  const ids = []
  for (var i = 0; i < cards.length && ids.length < MAX_IDS_PER_REFRESH; i++) {
    const id = cards[i].getAttribute("data-auction-id")
    if (id && ids.indexOf(id) === -1) ids.push(id)
  }
  if (ids.length === 0) return
  const url = "/listing_prices?ids=" + encodeURIComponent(ids.join(","))
  fetch(url, { credentials: "same-origin" })
    .then(function (res) { return res.ok ? res.json() : null })
    .then(function (payload) {
      if (!payload || typeof payload !== "object") return
      Object.keys(payload).forEach(function (id) {
        const entry = payload[id]
        if (entry && (entry.highest_ad_bid != null || entry.ad_publication_date != null)) {
          applyListingUpdate(id, entry)
        }
      })
    })
    .catch(function () {})
}

function scheduleDelayedListingRefresh() {
  if (_listingRefreshTimeout) clearTimeout(_listingRefreshTimeout)
  _listingRefreshTimeout = setTimeout(function () {
    _listingRefreshTimeout = null
    refreshListingPricesFromServer()
  }, LISTING_REFRESH_DELAY_MS)
}

function setupVisibilityRefresh() {
  if (window._auctionListingVisibilitySetup) return
  window._auctionListingVisibilitySetup = true
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible" && document.body.getAttribute("data-realtime-listing-prices") !== "false") {
      refreshListingPricesFromServer()
    }
  })
}

function getListingPollIntervalMs() {
  const container = document.getElementById("pills-online-auction")
  if (!container) return 30000
  const count = container.querySelectorAll("[data-auction-id]").length
  if (count > 300) return 0
  if (count > 200) return 60000
  if (count > 50) return 30000
  return 10000
}

function startListingPollIfNeeded() {
  if (window._auctionListingPollStarted) return
  if (document.body.getAttribute("data-realtime-listing-prices") === "false") return
  window._auctionListingPollStarted = true
  function tick() {
    if (document.visibilityState !== "visible") return
    if (!document.getElementById("pills-online-auction")) return
    var next = getListingPollIntervalMs()
    if (next > 0) {
      refreshListingPricesFromServer()
      window._auctionListingPollTimer = setTimeout(tick, next)
    } else {
      window._auctionListingPollTimer = setTimeout(tick, 60000)
    }
  }
  window._auctionListingPollTimer = setTimeout(tick, getListingPollIntervalMs())
}

function initAuctionListingRealtime() {
  if (document.body.getAttribute("data-realtime-listing-prices") === "false") return
  if (window._auctionListingSubscription) return
  window._auctionListingSubscription = subscribeToAuctionListing()
}

function scheduleListingInit() {
  initAuctionListingRealtime()
  setupVisibilityRefresh()
  startListingPollIfNeeded()
  if (!window._auctionListingSubscription) {
    setTimeout(initAuctionListingRealtime, 400)
  }
  if (!window._auctionListingSubscription) {
    setTimeout(initAuctionListingRealtime, 800)
  }
}

document.addEventListener("DOMContentLoaded", scheduleListingInit)
if (typeof Turbolinks !== "undefined" && Turbolinks.Events) {
  document.addEventListener("turbolinks:load", scheduleListingInit)
}
if (document.readyState !== "loading") {
  setTimeout(scheduleListingInit, 0)
}
document.addEventListener("DOMContentLoaded", function () {
  const tab = document.getElementById("pills-online-auction-tab")
  if (tab) {
    tab.addEventListener("shown.bs.tab", function () {
      initAuctionListingRealtime()
    })
  }
})

export { subscribeToAuctionListing, initAuctionListingRealtime }
